import Container from "../../../components/element/container";
import Col from "../../../components/element/col";
import Image from "../../../components/element/image";
import Row from "../../../components/element/row";
import { ConsignBanner, ConsignGetQuote, ConsignSoldIt, ConsignSubmit } from "../../../assets/images";
import { useTranslation } from "react-i18next";
import ConsignForm from "./consign.form";
import Icon from "../../../components/element/icon";
import useWindowDimension from "../../../components/hook/use.window.dimension";

export default function ConsignStep() {
  const { t } = useTranslation();
  const { isDesktop } = useWindowDimension();

  const stepList = [
    {
      img: ConsignSubmit,
      label: "Submit",
    },
    {
      img: ConsignGetQuote,
      label: "Get Quote",
    },
    {
      img: ConsignSoldIt,
      label: "Sold it!",
    },
  ];

  return (
    <Container className="consign-step">
      <Col className="_col consign-left-panel">
        <Col className="_col estimate-heading desktop-estimate-heading">
          <h1 className="_label estimate-title">
            <span className="estimate-accent">
              {t("Get Your Car Estimate")}{" "}
            </span>
            {t("VALUE")}
          </h1>
          <p className="_label estimate-subtitle">
            {t(
              "Get an instant market estimate for your car. it's free, fast and easy",
            )}
          </p>
        </Col>
        <section className="consign-hero">
          <Image
            src={ConsignBanner}
            alt={t("Car ready for consignment")}
            className="_img hero-image"
          />

          <Col className="_col offer-card">
            <p className="_label offer-kicker">{t("Platform Offer")}</p>
            <strong className="_label platform-offer">RM 98,000</strong>
            <span className="offer-divider" />
            <p className="_label offer-kicker">{t("Buyer Offer")}</p>
            <strong className="_label buyer-offer">RM 150,000</strong>
            <Row className="_row offer-difference">
              <span aria-hidden="true">↑</span>
              <Col className="_col">
                <strong>RM 57,000 Higher</strong>
                <small>{t("Than Market Value")}</small>
              </Col>
            </Row>
          </Col>
        </section>
        <Row className="_row estimate-progress desktop-estimate-progress">
          {stepList.map((step, index) => (
            <Row className="_row progress-group" key={step.label}>
              <Col className="_col progress-item">
                <Image src={step.img} alt="" className="_img progress-icon" />
                <p className="_label progress-label">{t(step.label)}</p>
              </Col>
              {index < stepList.length - 1 && (
                <Icon
                  icon="solar:arrow-right-broken"
                  className="_svg progress-arrow mx-4"
                />
              )}
            </Row>
          ))}
        </Row>
      </Col>
      <Container className="consign-estimate-card">
        {!isDesktop && (
          <Col className="_col estimate-progress">
            <Col className="_col estimate-heading">
              <h1 className="_label estimate-title">
                <span className="estimate-accent">
                  {t("Get Your Car Estimate")}{" "}
                </span>
                {t("VALUE")}
              </h1>
              <p className="_label estimate-subtitle">
                {t("Get an instant market estimate for your car.")}
                <br />
                {t("It's free, fast and easy")}
              </p>
            </Col>
            <Row className="_row estimate-progress">
              {stepList.map((step, index) => (
                <Row className="_row progress-group" key={step.label}>
                  <Col className="_col progress-item">
                    <Image
                      src={step.img}
                      alt=""
                      className="_img progress-icon"
                    />
                    <p className="_label progress-label">{t(step.label)}</p>
                  </Col>
                  {index < stepList.length - 1 && (
                    <Icon
                      icon="solar:arrow-right-broken"
                      className="_svg progress-arrow mx-4"
                    />
                  )}
                </Row>
              ))}
            </Row>
          </Col>
        )}
        <ConsignForm />
      </Container>
    </Container>
  );
}
